import { gql } from '@apollo/client'

// The operation name must exactly equal the root query field name: the export endpoint resolves it
// against the schema's Query type and 500s on anything else (bugs 37321, 39141).
export const EXPORT_MATERIAL_EMISSION_FACTORS_QUERY = gql`
  query PackagingEmissionFactors(
    $first: Int
    $after: String
    $where: EmissionFactorsGraphQlFilterInput
    $order: [EmissionFactorsGraphQlSortInput!]
  ) {
    packagingEmissionFactors(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        code
        state
        isRecycled
        includesProcessingImpacts
        packagingMaterialClass
        packagingMaterialCategory
        packagingMaterialName
        countryName
        countryISOCode
        regionIdentifier
        functionalUnit
        dataOrigin
        dataOriginComment
        proxyNote
        landUse
        biodiversity
        carbon
        eutrophication
        waterUsage
        waterUsageIncludingWasterScarcity
        dataQualityReliabilityScore
        lastPublishedDate
        researcherName
        researcherEmail
        isVerified
        verifiedOn
        verifiedByName
        lastUpdatedName
        updated
      }
    }
  }
`
